// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__n3U8x","label":"styles_label__2TjLq"};